import request from '@/utils/request';

//获取我的任务列表
export const getTaskList = (values) => {
  return request('/message/myTask/queryMyTasksPage', {
    method: 'POST',
    data: values,
  });
};
